export default __webpack_public_path__ + "static/media/continue_btn.2571b1ea.png";